<template>
  <div class="modal" style="display: block; margin-top: 100px">
    <div class="modal-dialog" role="document">
      <form v-on:submit.prevent="submit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Sign in with Google OAuth to your *@improvmx.com Google account.
            </h5>
          </div>
          <div class="modal-body">
            <div class="google-signin-container">
              <div
                id="g_id_onload"
                :data-client_id="GOOGLE_CLIENT_ID"
                data-callback="handleCredentialResponse"
                data-auto_prompt="false"
              ></div>
              <p class="error" v-if="error">{{ error }}</p>

              <!-- Development bypass button -->
              <div v-if="isDevelopmentMode" class="mt-3">
                <hr />
                <p class="text-muted small">Development Mode</p>
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="devBypassLogin"
                >
                  🚧 Skip Login (Dev Mode)
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const getGoogleClientId = () => {
  const hostname = window.location.host;

  if (hostname.includes("captain.improvmx.com")) {
    // Production environment
    return "385653430017-qevcm9v1jm7pvb2tqg58knfa5n8f2fpo.apps.googleusercontent.com";
  } else if (hostname.includes("captain.improxmx.com")) {
    // Staging environment
    return "385653430017-jimbg48pd9kdfdl8dle1b7i88ho9ni55.apps.googleusercontent.com";
  } else {
    // Development/fallback environment
    return "385653430017-jimbg48pd9kdfdl8dle1b7i88ho9ni55.apps.googleusercontent.com";
  }
};

const GOOGLE_CLIENT_ID = getGoogleClientId();

export default {
  data() {
    return {
      error: null,
      GOOGLE_CLIENT_ID,
    };
  },
  computed: {
    isDevelopmentMode() {
      return (
        window.location.host.includes("localhost") ||
        window.location.host.includes("127.0.0.1")
      );
    },
  },
  created() {
    if (window.localStorage.getItem("sessionId")) {
      this.$http.post("check").then((response) => {
        this.$router.push({ name: "dashboard" });
      });
    }

    // Initialize Google Sign In when script loads
    const checkGoogleScriptLoaded = () => {
      if (
        window.google &&
        window.google.accounts &&
        window.google.accounts.id
      ) {
        try {
          google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: this.handleGoogleSignIn,
          });
        } catch (initError) {
          console.error("Error initializing Google Sign-In:", initError);
        }
      } else {
        setTimeout(checkGoogleScriptLoaded, 100);
      }
    };
    checkGoogleScriptLoaded();
  },
  mounted() {
    // Render the button after the component is mounted
    if (window.google && window.google.accounts && window.google.accounts.id) {
      const buttonElement = document.getElementById("g_id_onload");
      if (buttonElement) {
        try {
          window.google.accounts.id.renderButton(buttonElement, {
            theme: "outline",
            size: "large",
          });
        } catch (renderError) {
          console.error("Error rendering Google Sign-In button:", renderError);
        }
      }
    }
  },
  methods: {
    handleGoogleSignIn(response) {
      // Get the JWT ID token from the Google credential response
      const idToken = response.credential;

      this.error = null;

      // Send the token to the api backend for verification
      this.$http
        .post("google-auth", {
          id_token: idToken,
        })
        .then(
          (response) => {
            window.localStorage.setItem("username", response.data.email);
            window.localStorage.setItem("loggedIn", true);

            this.$http.post("check", {}, {}).then(
              (checkResponse) => {
                window.location.href = "/";
              },
              (checkError) => {
                console.error("Auth check failed:", checkError);
                this.error =
                  "Authentication succeeded but verification failed (see console logs).";
              },
            );
          },
          (error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              this.error = error.response.data.error;
            } else {
              this.error = "Google authentication failed: " + error.bodyText;
            }
          },
        );
    },
    devBypassLogin() {
      // Set development credentials
      window.localStorage.setItem("username", "dev@improvmx.com");
      window.localStorage.setItem("loggedIn", true);

      // Redirect to dashboard
      this.$router.push({ name: "dashboard" });
    },
  },
};
</script>

<style scoped>
form p.error {
  font-weight: bold;
  color: #dc3545;
  text-align: center;
}

.google-signin-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
